import { VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React, { useMemo } from 'react';

export declare namespace TableTitleTypes {
  interface Props {
    width: number;
    children: React.ReactNode;
  }
}

export const TitleItem = ({ width, children }: TableTitleTypes.Props) => {
  const finalWidth = useMemo(() => Math.max(1, Math.min(width, 100)) + '%', [width]);

  return (
    <VStack
      width={finalWidth}
      style={{ gap: Utils.Token.ToInt(Spacing, 'inline.quarck') }}
      alignItems="center">
      {children}
    </VStack>
  );
};
